export default {
  title: {
    id: 'buyback_swap_scarab_title',
    defaultMessage: 'beetle!',
  },
  content: {
    id: 'buyback_swap_scarab_content',
    defaultMessage: "We don't have any offer yet for this kind of product...",
  },
}
